import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { eIntegrationType } from '../../../../../../../providers/IntegrationsProvider/Integrations.enums.ts';
import { IntegrationsService } from '../../../../../../../providers/IntegrationsProvider/Integrations.service.ts';
import { tGetMetaPagesData } from '../../../../../../../providers/IntegrationsProvider/Integrations.types.ts';
import { useSyncConversationsContext } from '../../../../../../../providers/SyncConversationsProvider/SyncConversations.context.tsx';
import { eAlertType } from '../../../../../../../providers/ToastProvider/Toast.enum.ts';
import { useToastContext } from '../../../../../../../providers/ToastProvider/Toast.hook.ts';
import { useMetaConnectionModalContext } from '../../MetaConnectionModal.hook.ts';
import { useModalsContext } from '../../../../../../../providers/ModalsProvider/Modals.context.ts';

export default function useMetaPage() {
  const [processing, setProcessing] = useState<boolean>(false);
  const [connectionCompleted, setConnectionCompleted] =
    useState<boolean>(false);
  const { setLoading, setConnected } = useMetaConnectionModalContext();
  const { setMetaConnectionModalIsOpen } = useModalsContext();
  const { addAlert } = useToastContext();
  //const { setSyncConversationsStatus } = useModalsContext();
  const { setSelectedIntegration, setSelectedPageUuid } =
    useSyncConversationsContext();
  const { t } = useTranslation('dashboard/dashboard');

  const selectPage = async (page: tGetMetaPagesData) => {
    setProcessing(true);
    setLoading(true);
    try {
      await IntegrationsService.selectFacebookPage({
        pageId: page.uuid,
      }).then(() => {
        setSelectedIntegration(eIntegrationType.MESSENGER);
        setSelectedPageUuid(page.uuid);
        setConnectionCompleted(true);
        setConnected(true);
        setMetaConnectionModalIsOpen(false);
        // TODO: this is blocked by meta endpoint depcreation 9/04/2025, resolve conversation syncs
        //setSyncConversationsStatus(SyncConversationsEnum.QUESTION);
        addAlert({
          type: eAlertType.SUCCESS,
          message: t('components.modals.MetaConnection.successfulConnection'),
        });
      });
    } catch (error) {
      addAlert({
        type: eAlertType.ERROR,
        message:
          (error as Error).message ||
          t('components.modals.MetaConnection.connectionError'),
      });
    }
    setLoading(false);
    setProcessing(false);
  };

  return {
    selectPage,
    processing,
    connectionCompleted,
    setConnectionCompleted,
  };
}
